import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useRevenueSelector() {
  const RevenueListGridData = useSelector((state) => state.Revenue.list_data?.revenue) || []; // List data
  const RevenueListViewData = useSelector((state) => state.Revenue.view_data) || []; // view data
  const RevenuePartnerDetails =
    useSelector((state) => state.Revenue.partner_details?.partnerDetails) || []; // partner details
  const RevenueCommentLog =
    useSelector((state) => state.Revenue.comment_log?.revenueCommentLogs) || []; // comment log

  const RevenuePartnerDrop = useMemo(
    () =>
      (RevenuePartnerDetails || [])?.map((item) => ({
        label: item?.partnerName,
        value: item?.partnerId
      })),
    [RevenuePartnerDetails]
  );

  return { RevenueListGridData, RevenueListViewData, RevenuePartnerDrop, RevenueCommentLog };
}
